/**
 * GroupsPeopleList
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import PersonFullName from '../../../../../../../../../../components/PersonFullName';

// Selectors
import { makeSelectGroupPeopleIds } from '../../../../../../../../../../services/groupPeople/selectors';

interface Props {
    peopleIds?: number[];
}

export class GroupsPeopleList extends React.PureComponent<Props> {
    render() {
        const { peopleIds } = this.props;
        if (!peopleIds || !peopleIds.length) return null;
        return peopleIds.map((id, index) => (
            <span key={id}>
                {!!index && ', '}
                <PersonFullName personId={id} />
            </span>
        ));
    }
}

const mapStateToProps = createStructuredSelector({
    peopleIds: makeSelectGroupPeopleIds()
});

export default connect(mapStateToProps)(GroupsPeopleList);
